import { eocCommonResources } from '@atlassian/eoc-resources';
import {
	getTimeTemplatesResource,
	getTimezonesResource,
} from '@atlassian/eoc-schedule-common/resources';

const resources = [getTimezonesResource, getTimeTemplatesResource, ...eocCommonResources()];

export { resources };
